import { useDocking } from "providers/DockingProvider";
import DockingActionFeedback from "./DockingActionFeedback";

const Docking = () => {
    const {
        actionStatus,
        actionResult,
        actionFeedback,
        showActionFeedback,
        setShowActionFeedback,
        isActionValid,
        activeActionLabel,
        handleActionCancel,
        handleForceClose,
    } = useDocking();

    return (
        <DockingActionFeedback
            visible={showActionFeedback}
            feedback={actionFeedback}
            result={actionResult}
            status={actionStatus}
            actionLabel={activeActionLabel}
            isActionValid={isActionValid}
            onCancel={handleActionCancel}
            onClose={() => setShowActionFeedback(false)}
            onForceClose={handleForceClose}
        />
    );
};

export default Docking;
